// A chat that outlives one page reload: an action that ends in a reload (the
// great room's Apply) would otherwise empty the conversation, since it lives
// only in ChatProvider's state. Kept in this tab's sessionStorage just before
// the reload and taken back — once — when ChatProvider mounts again: the chat
// as shown, and the conversation the next turn carries (chatTranscript.js).

const KEY = 'chat.afterReload';

const save = (kept) => window.sessionStorage.setItem(KEY, JSON.stringify(kept));

/**
 * Keep the chat for the next page load of this tab.
 * @param {Array} messages  the chat as shown
 * @param {object|null} conversation  { transcript, coveredId } — screenshots
 *   can make it too big for storage, and then only the chat is kept
 */
export function keepChatForReload(messages, conversation = null) {
  try {
    save({ messages, conversation });
  } catch {
    try {
      save({ messages, conversation: null });
    } catch {
      // storage refused: the reload empties the chat, as it did before
    }
  }
}

/** The kept chat, removed as it is read; empty when there is none. */
export function restoreChatAfterReload() {
  const none = { messages: [], conversation: null };
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return none;
    window.sessionStorage.removeItem(KEY);
    const kept = JSON.parse(raw);
    // a tab reloading across the deploy that added the conversation
    const { messages, conversation = null } = Array.isArray(kept)
      ? { messages: kept }
      : kept;
    return {
      messages: messages.map((m) => ({
        ...m,
        timestamp: m.timestamp ? new Date(m.timestamp) : new Date(),
      })),
      conversation,
    };
  } catch {
    return none;
  }
}
